import { VendorService } from '@controlling/proxy/controlling/controllers';
import { CertificationCodeService } from '../proxy/planning/controllers';
import { FieldDefinition, FieldBuilder, MenuCategories, MenuSubcategories, MENU_CATEGORY_KEY, MENU_SUBCATEGORY_KEY, MENU_NAME_SUFFIX } from '@zendra/shared';
// import { CertificationService } from '../proxy/controlling/controllers'

FieldBuilder.setNamespace('Planning');

export const FORESTRYMANAGEMENT_FIELDS: FieldDefinition[] = [
  FieldBuilder
    .foreignKey('certificationCodeId', 'Entity.CertificationCode', CertificationCodeService)
    .required()
    .displayFromNested('certificationCode.name')
    .sortBy('certificationCode.name')
    .build(),
  FieldBuilder
    .date('expirationDate', 'Entity.ForestryManagement.ExpirationDate')
    .required()
    .build(),
  FieldBuilder
    .text('notes', 'Entity.ForestryManagement.Notes')
    .required()
    .minLength(1)
    .maxLength(80)
    .build(),
  //TO DO: Add when Planning module entity is created in the future
  // FieldBuilder.foreignKey(
  //   'certificationTypeId',
  //   'Entity.CertificationType',
  //   CertificationService
  // )
  //   .displayFromNested('certificationType.name')
  //   .sortBy('certificationType.name')
  //   .build(),
  FieldBuilder
    .checkbox('isNotCertificationValue', 'Entity.ForestryManagement.IsNotCertificationValue')
    .build(),
  FieldBuilder // TODO: when the orchestrator is implemented, refactor this nested logic into it
  .foreignKey(
    'vendorId',
    'Entity.ForestryManagement.Vendor',
    VendorService
  )
    .displayFromNested('vendor.name')
    .sortBy('vendor.name')
    .build(),
];

export const FORESTRYMANAGEMENT_CONFIG = {
  entityName: 'ForestryManagement',
  localizationKey: 'Planning::Entity.ForestryManagement',
  fields: FORESTRYMANAGEMENT_FIELDS,
  permission: 'PlanningCertification.ForestryManagements',
  showInMenu: true,
  menuCategory: MENU_CATEGORY_KEY + MenuCategories.Planning + MENU_NAME_SUFFIX,
  menuSubcategory: MENU_SUBCATEGORY_KEY + MenuSubcategories.Certification + MENU_NAME_SUFFIX,
};
